"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _Button = _interopRequireDefault(require("../../../../Button/Button"));
var _constants = require("../../../../constants");
var _CurrencyDropdown = _interopRequireDefault(require("../../../../CurrencyDropdown/CurrencyDropdown"));
var BookingFunnel = function BookingFunnel(_ref) {
  var supportedCurrencies = _ref.supportedCurrencies,
    homePath = _ref.homePath;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "mobile-menu__bottom"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "margin-top-md flex items-center justify-left"
  }, supportedCurrencies && /*#__PURE__*/_react["default"].createElement(_CurrencyDropdown["default"], {
    supportedCurrencies: supportedCurrencies,
    buttonType: _constants.BUTTON_TYPES.GHOST
  }), /*#__PURE__*/_react["default"].createElement("a", {
    href: homePath ? homePath : '/'
  }, /*#__PURE__*/_react["default"].createElement(_Button["default"], {
    className: "margin-left-sm",
    text: "Back to home",
    buttonType: _constants.BUTTON_TYPES.PRIMARY
  }))));
};
BookingFunnel.propTypes = {
  supportedCurrencies: _propTypes["default"].array,
  homePath: _propTypes["default"].string.isRequired
};
var _default = exports["default"] = BookingFunnel;